<template>
    <main>
        <!-- breadcrumb-area-start -->
        <div class="it-breadcrumb-area it-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="it-breadcrumb-content z-index-3 text-center">
                            <div class="it-breadcrumb-title-box">
                                <h3 class="it-breadcrumb-title">Eligiblity</h3>
                            </div>
                            <div class="it-breadcrumb-list-wrap">
                                <div class="it-breadcrumb-list">
                                    <span><a href="#">HOME</a></span>
                                    <span class="dvdr">//</span>
                                    <span>Eligiblity</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- breadcrumb-area-end -->

        <div class="it-sv-details-area pt-120 pb-120">
            <div class="container">
                <div class="row">
                    <div class="col-xl-8 col-lg-8">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="it-sv-details-top-content mb-50">
                                    <h4 class="it-sv-details-title">Eligiblity Criteria</h4>
                                    <p>1) Passed with minimum of 50% marks in aggregate (45% in case of candidates from
                                        reserved category belonging to Maharashtra State only (SC/ST/NT/SBC/OBC) in any
                                        Bachelor's degree of minimum 3 years duration in any discipline recognised by
                                        the
                                        University of Mumbal.</p>
                                    <p>2) Maharashtra CET/CAT/CMAT/ATMA is compulsory for MBA/MMS Admission</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>

</template>
<script>
export default {
    name: "EligiblityView"
};
</script>
